module.exports = __webpack_public_path__ + "static/media/react1Form.d39835e4.png";